<template>
   <div class="page">
     <page-header ></page-header>

     <div class="banners"></div>

     <div class="c-container">
       <div class="main">
          <div class="title">
            <img src="@/assets/images/xygame.png">
          </div>

          <div class="game-center">
            <div class="nav">
              <ul>
                <li :class="index == current ? 'current' : ''" @click="selectCSS(index);" v-for="(item,index) in list" :key="index"><i class="icon"></i><span>{{item.title}}</span><i class="triangle"></i></li>
              </ul>
            </div>
            <div class="games-lists">
              <div class="game" v-for="(item,index) in list[current].data" :key="index" @click="toGames(item.type)">
                <div class="tit">{{item.tit}}</div>
                <div class="img"><img :src="item.src"></div>
                <div class="down">
                  <div class="code"><img :src="item.code"></div>
                  <div class="txt">扫二维码下载</div>
                </div>
              </div>
            </div>
          </div>

       </div>
     </div>
     <page-footer v-if="$route.meta.hasFooter"></page-footer>
   </div>
</template>
<script>
import Vue from 'vue'

export default {
  components: {
    pageFooter: () => import('@/components/footer'),
    pageHeader: () => import('@/components/layout/page-header')
  },
  data () {
    return {
      navList : ['全部游戏','麻将系列','纸牌系列','字牌系列'],
      list : [
        {
          title : '全部游戏',
          data : []
        },
        {
          title : '麻将系列',
          data : [
            {
              tit : '红中麻将',
              src : require('@/assets/images/ac-hz.jpg'),
              code : require('@/assets/images/xyqp-ewm.png'),
              type : 3
            },
            {
              tit : '转转麻将',
              src : require('@/assets/images/ac-zz.jpg'),
              code : require('@/assets/images/xyqp-ewm.png'),
              type : 4
            }
          ]
        },
        {
          title : '纸牌系列',
          data : [
            {
              tit : '斗地主',
              src : require('@/assets/images/ac-ddz.jpg'),
              code : require('@/assets/images/xyqp-ewm.png'),
              type : 1
            },
            {
              tit : '闲逸跑得快',
              src : require('@/assets/images/ac-pdk.jpg'),
              code : require('@/assets/images/xyqp-ewm.png'),
              type : 6
            }
          ]
        },
        {
          title : '字牌系列',
          data : [
            {
              tit : '闲逸碰碰',
              src : require('@/assets/images/ac-xyph.jpg'),
              code : require('@/assets/images/xyqp-ewm.png'),
              type : 2
            }
          ]
        }
      ],
      current : 0,
    }
  },
  created () {
    let list = this.list;
    let data = []
    list.forEach( (item , index) => {
      if(index != 0){
        let d = item.data;
        d.forEach( items => {
          data.push(items)
        })
      }
    })
    list[0].data = data;
    this.list = list;
    console.log(list)
  },
  mounted () {
  },
  
  methods: {
    selectCSS(e){
      this.current  =e;
    },
    toGames(e){
      let path = `/gameDetail?type=${e}`
      this.$router.push({
          path
      })
    }
  }
}
</script>
<style lang="less" scoped>

.banners{
  height: 210px;
  background: url(../../assets/images/gct-barnner.jpg) no-repeat center;
  background-size: cover;
}

.c-container{
	width: 100%;
	clear: all;
	overflow: hidden;
	background-image: url(../../assets/images/girl.png),url(../../assets/images/d-bg.png);
	background-position: left top, right bottom;
	background-repeat: no-repeat, no-repeat;
  .main{
    max-width: 512px;
    margin: 15px auto 0;
    position: relative;
    padding: 0 10px;
    box-sizing: border-box;
    .title{
      border-bottom: 1px solid #ccc;
      margin-bottom: 10px;
      padding-bottom: 6px;
      padding-left: 8px;
      img{
        width: 100px;
        height: auto;
      }
    }
  }

  .game-center{
    width: 100%;
    display: flex;
    justify-content: space-between;
    .nav{
      width: 122px;
      li{
        padding-top: 15px;
        padding-bottom: 15px;
        border-bottom: 1px solid #ccc;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 10px;
        .icon {
          display: inline-block;
          width: 30px;
          height: 30px;
          background-size: auto 100%
        }
        span{
          margin-left: 8px;
        }
        &:hover{
          border-bottom: 1px solid #57bdf4;
          span{
            color: #57bdf4;
          }
        }
        &.current{
          border-bottom: 1px solid #57bdf4;
          span{
            color: #57bdf4;
          }
        }
        &:nth-child(1) .icon {
          background-image: url("../../assets/images/all-grey.png") ;
          background-size: 100% 100%
        }
        &:nth-child(1).current .icon {
          background-image: url("../../assets/images/all-green.png")
        }
        &:nth-child(1):hover .icon {
          background-image: url("../../assets/images/all-green.png")
        }
        &:nth-child(2) .icon {
          background-image: url("../../assets/images/mj-grey.png") ;
          background-size: 100% 100%
        }
        &:nth-child(2).current .icon {
          background-image: url("../../assets/images/mj-green.png")
        }
        &:nth-child(2):hover .icon {
          background-image: url("../../assets/images/mj-green.png")
        }
        &:nth-child(3) .icon {
          background-image: url("../../assets/images/zhipai-grey.png") ;
          background-size: 100% 100%
        }
        &:nth-child(3).current .icon {
          background-image: url("../../assets/images/zhipai-green.png")
        }
        &:nth-child(3):hover .icon {
          background-image: url("../../assets/images/zhipai-green.png")
        }
        &:nth-child(4) .icon {
          background-image: url("../../assets/images/zipai-grey.png") ;
          background-size: 100% 100%
        }
        &:nth-child(4).current .icon {
          background-image: url("../../assets/images/zipai-green.png")
        }
        &:nth-child(4):hover .icon {
          background-image: url("../../assets/images/zipai-green.png")
        }

        .triangle{
          margin-left: 17px;
          width: 7px;
          height: 8px;
        }
        &:hover .triangle{
          background-image: url('../../assets/images/triangle-green.png');
          background-size: 100% 100%;
        }
        &.current .triangle{
          background-image: url('../../assets/images/triangle-green.png');
          background-size: 100% 100%;
        }

      }

      

    }

    .games-lists{
      width: 380px;
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
      
      .game{
        width: 180px;
        height: 170px;
        box-sizing: border-box;
        border: 1px solid #ccc;
        border-radius: 10px;
        background: #fff;
        margin-left: 6px;
        margin-bottom: 6px;
        padding: 5px;
        text-align: center;
        overflow: hidden;
        cursor: pointer;
        .tit{
          font-size: 10px;
          margin-bottom: 6px;
        }
        .img{
          margin-bottom: 6px;
          img{
            width: 164px;
            height: 88px;
          }
        }
        .down{
          display: flex;
          justify-content: space-between;
          align-content: center;
          div{
            flex: 1;
          }
          .txt{
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 8px;
            border-left: 1px solid #f5f5f5;
          }
        }
        .code{
          
          img{
            width: 40px;
            height: 40px;
          }
        }
      }
    }
  }
}


@media (max-width:800px) {
  .c-container{
    .game-center{
      .nav{
        width: 180px;
      }
      .games-lists{
        width: 300px;
        justify-content: center;
      }
    }
  }
}


</style>
